/* eslint-disable */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTheme } from '../../theme-context';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { tryToFetchTeamMembersSidebar } from '../../store/brokers/partners/teams/teamsSlice';
import TeamsModal from '../../components/teams/TeamsModal';
import { IToast } from '../../interfaces/components/IToast';
import Toast from '../../shared/toast';
import ActivitesModal from '../../components/activities/ActivitiesModal';

interface IRightSidebar {
    onClickOpenChat: (action?: any) => void;
    isMobile?: boolean;
    isCollapsed?: boolean;
    toggleCollapse?: () => void;
    isExecView?: boolean;
}

const RightSidebar = ({
    onClickOpenChat,
    isMobile = false,
    isCollapsed,
    toggleCollapse,
    isExecView = false,
}: IRightSidebar) => {
    const dispatch = useAppDispatch();
    const { theme } = useTheme();
    const [notifications, setNotifications] = useState<any>();
    const [members, setMembers] = useState<any>();
    const [activitites, setActivitites] = useState<any>();
    const [showMembersModal, setShowMembersModal] = useState<boolean>(false);
    const [showActivitiesModal, setShowActivitiesModal] = useState<boolean>(false);
    const [showToast, setShowToast] = useState<IToast | null>();
    const notificationsData = useAppSelector((state) => state.notifications)
    const activitiesData = useAppSelector((state) => state.activities)
    const membersData = useAppSelector((state) => state.teams)

    useEffect(() => {
        setNotifications(notificationsData?.notifications?.data?.elements)
    }, [notificationsData])

    useEffect(() => {
        setActivitites(activitiesData?.activities?.data?.elements)
    }, [activitiesData])

    useEffect(() => {
        setMembers(membersData?.teamMembersSidebar?.data?.elements)
    }, [membersData])

    const onGettingData = async () => {
        try {
            const data = {
                pageSize: 5,
                pageNumber: 1,
                data: {
                    status: 'live'
                }
            }
            await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap();
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingData();
    }, [])

    const onClickShowTeamModals = () => {
        return;
    }

    const onClickShowActivititesModals = () => {
        setShowActivitiesModal(!showActivitiesModal)
    }

    const onSuccessfullyDeleted = async () => {
        setShowToast({ type: 'success', message: 'Members successfully deleted' });
        onGettingData();
    }


    return (
        <div
            className={`${isMobile
                ? 'w-64 h-full flex flex-col bg-white dark:bg-bgColor-darkMode'
                : `hidden md:flex md:flex-col md:inset-y-0 md:right-0 md:fixed border-l dark:border-borderColor-darkMode dark:bg-bgColor-darkMode transition-all duration-300 ${isCollapsed ? 'md:w-16' : 'md:w-64'
                }`
                }`
            }
        >
            <div className='min-h-screen w-full p-4 overflow-y-auto px-3 py-2'>
                {!isMobile && toggleCollapse && (
                    <div className="flex flex-col items-start mb-4">
                        <button
                            onClick={toggleCollapse}
                            className="p-2 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md transition"
                        >
                            <img
                                src={
                                    isExecView
                                        ? theme === 'dark'
                                            ? '/svg/rightside-icon-white.svg'
                                            : '/svg/sidebar_open.svg'
                                        : theme === 'dark'
                                          ? '/assets/layout/rightside-icon-white.svg'
                                          : '/assets/layout/rightside-icon.svg'
                                }
                                alt="Toggle"
                                className={`w-6 h-6 ${isCollapsed ? '' : 'rotate-180'}`}
                            />
                        </button>
                        {isCollapsed &&
                            <>
                                {/* <div className='p-2 my-2'>
                                    <img src={theme === 'dark' ? '/assets/layout/notifications-white.svg' : '/assets/layout/notifications.svg'} className='object-contain w-[20px]' />
                                </div>
                                <div className='p-2 my-2'>
                                    <img src={theme === 'dark' ? '/assets/layout/activities-white.svg' : '/assets/layout/activities.svg'} className='object-contain w-[20px]' />
                                </div> */}
                                <div className='p-2 my-2'>
                                    <img
                                        src={
                                            isExecView
                                                ? theme === 'dark'
                                                    ? '/svg/teams-white.svg'
                                                    : '/svg/sidebar_team.svg'
                                                : theme === 'dark'
                                                  ? '/assets/layout/teams-white.svg'
                                                  : '/assets/layout/teams.svg'
                                        }
                                        className='object-contain w-[20px]'
                                    />
                                </div>
                            </>
                        }
                    </div>
                )}
                {!isCollapsed &&
                    <>
                        {/* <div className='mb-7'>
                            <h2 className='text-sm font-semibold mb-4 dark:text-primary-dark'>Notifications <span className='text-primary-light !font-normal'>(0 Unread)</span></h2>
                            {notifications && notifications?.length > 0 && notifications?.map((item: any, idx: number) => {
                                const timeAgo = moment(item?.createdAt).fromNow();
                                return (
                                    <div key={idx} className='flex flex-row items-start mb-4'>
                                        {item?.title === 'New user registered' ? <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2'} />
                                            : <div className='min-w-[30px] min-h-[30px] mr-2 !rounded-8 bg-[#E5ECF6]'>
                                            </div>
                                        }
                                        <div>
                                            <p>{item?.title}</p>
                                            <p className='text-primary-light dark:text-primary-dark mt-1'>{timeAgo}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> */}
                        {/* <div className='mb-7'>
                            <div className='cursor-pointer hover:opacity-80' onClick={onClickShowActivititesModals}>
                                <h2 className='text-sm font-semibold mb-4 dark:text-primary-dark'>Activities <span className='text-primary-light !font-normal'>({activitiesData?.activities?.data?.page?.totalElements || 0} Today)</span></h2>
                            </div>
                            {(activitites && activitites?.length > 0) && activitites?.filter((item: any, index: number) => index < 5)?.map((item: any, idx: number) => {
                                const timeAgo = moment(item?.createdAt).fromNow();
                                return (
                                    <div key={idx} className='mb-4 flex flex-row items-start'>
                                        <img src={'/assets/navigation-icons/sidebar/activities.svg'} className='object-contain w-[30px] mr-2' />
                                        <div className='w-[85%]'>
                                            <p className='truncate dark:text-primary-dark max-w-[200px]'>{item?.name}</p>
                                            <p className='text-primary-light mt-1'>{timeAgo}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> */}
                        <div className='mb-7'>
                            <div className='flex flex-row justify-between items-center mb-4 '>
                                <div>
                                    <h2 className='text-sm font-semibold dark:text-primary-dark'>Team <span className='text-primary-light !font-normal'>({membersData?.teamMembers?.data?.page?.totalElements} Members)</span></h2>
                                </div>
                            </div>
                            {(members && members?.length > 0) && members?.map((item: any, idx: number) => {
                                return (
                                    <div key={idx} className='flex flex-row mb-4 items-center dark:text-primary-dark cursor-default'>
                                        {item?.userIcon ? <img src={item?.userIcon} className='object-contain w-[30px] mr-2 !rounded-full' /> :
                                            <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2 !rounded-full'} />}
                                        {(item?.name || item?.lastName) ?
                                            <div className='w-[80%]'>
                                                <p title={`${item?.name} ${item?.lastName}`} className='truncate'>{item?.name} {item?.lastName}</p>
                                            </div>
                                            : <div className={'w-[80%]'}>
                                                <p title={item?.email} className='truncate'>{item?.email}</p>
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </>
                }
            </div>
            {showMembersModal &&
                <TeamsModal
                    openModal={showMembersModal}
                    handleCloseModal={onClickShowTeamModals}
                    SuccessfullyDeleted={onSuccessfullyDeleted}
                />
            }
            {showActivitiesModal &&
                <ActivitesModal
                    openModal={showActivitiesModal}
                    handleCloseModal={onClickShowActivititesModals}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}

export default RightSidebar;